import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationsService } from '@/services/integrations';
import {
  POLICY_BATCH_FACETS_QUERY_KEY,
  POLICY_BATCH_SUMMARY_QUERY_KEY,
} from './use-policy-batch-mutations.hook';

export function useUploadPolicyBatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => integrationsService.uploadPolicyBatch(file),
    onSuccess: result => {
      // Importação muda ramos/origens existentes e o saldo dos pools; a listagem a
      // página já recarrega ao fechar o modal.
      if (result.success) {
        queryClient.invalidateQueries({
          queryKey: POLICY_BATCH_FACETS_QUERY_KEY,
        });
        queryClient.invalidateQueries({
          queryKey: POLICY_BATCH_SUMMARY_QUERY_KEY,
        });
      }
    },
  });
}
